module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "location-marker.24d85708.svg";